import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-forms',
  templateUrl: './forms.component.html'
})
export class FormsComponent implements OnInit {

  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }

}
